module.exports = __webpack_public_path__ + "static/media/ks_background.c8241413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/ks_background.png
// module id = 2514
// module chunks = 0